import { createDialog } from '@patsnap/tahiti-core';

/**
 * 创建分享链接对话框服务
 * @returns 对话框服务工厂函数
 */
export function createShareLinkDialogService() {
    return createDialog(() => import('@/presentation/components/share-link-dialog/ShareLinkDialog.vue'));
}
